/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumChatActivityStatus = "assigned" | "closed" | "pending" | "unassigned" | "%future added value";
export type Chat_Patient = {
    readonly chatActivity: {
        readonly status: EnumChatActivityStatus | null;
        readonly deleted: number | null;
        readonly " $fragmentRefs": FragmentRefs<"ActionsChatActivity_ChatActivity">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"InfiniteScrollMessages_Patient" | "ChatInput_Patient">;
    readonly " $refType": "Chat_Patient";
};
export type Chat_Patient$data = Chat_Patient;
export type Chat_Patient$key = {
    readonly " $data"?: Chat_Patient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Chat_Patient">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Chat_Patient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatActivity",
      "kind": "LinkedField",
      "name": "chatActivity",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deleted",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActionsChatActivity_ChatActivity"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InfiniteScrollMessages_Patient"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatInput_Patient"
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
(node as any).hash = '58f180ecdc84e0eba550ebf7eb2f4885';
export default node;
